import styled from 'styled-components';
import { generateSpacing } from 'styles/spaces';
import { Title as TitleCSS } from 'styles/typographies';
import { PageWrapper } from 'pages/styles';

export const SuccessfulOrderWrapper = styled(PageWrapper)`
  @media (max-width: 900px) {
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
  }
`;

export const MarkIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  border-radius: 50%;
  width: 70px;
  height: 70px;
  font-size: 35px;
  background-color: #13ab87;
`;

export const TitleWrapper = styled.div`
  text-align: center;
  margin: ${generateSpacing(10, 0)};
`;

export const Title = styled.span`
  ${TitleCSS}
`;

export const Instructions = styled.div`
  max-width: 660px;
  margin: 0 auto;
  font-size: 0.9rem;
  font-weight: 600;
  text-align: center;
`;

export const InstructionParagraph = styled.p`
  margin-bottom: ${generateSpacing(10)};
`;
